import { SystemCurrency } from '@okletsplay/core';
import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { UserBalanceDto } from 'app/interfaces/dto';
import { AppState } from 'app/interfaces/store';
import {
  convertCryptoToUsd,
  FiatCurrencyDisplay,
  formatCrypto,
  formatFiat,
} from 'shared/utils/currency';
import { WalletState } from './interfaces/wallet-state';

const walletState = (state: AppState): WalletState => state[EntityStoreName.Wallet];

const getBalanceFormatted = (wallet: WalletState) => formatCrypto(wallet.entity.balance);

const getBalanceInUsdFormatted = ({ entity }: WalletState, currencyDisplay: FiatCurrencyDisplay) =>
  formatFiat(convertCryptoToUsd(entity.balance, entity.exchangeRate), currencyDisplay);

const balanceInFiat = (currencyDisplay: FiatCurrencyDisplay = 'symbol') =>
  createSelector(walletState, (state: WalletState) =>
    getBalanceInUsdFormatted(state, currencyDisplay)
  );

export const walletSelector = {
  balance: createSelector(walletState, ({ entity }: WalletState) => entity.balance),
  asAccounts: createSelector(walletState, ({ entity }: WalletState): UserBalanceDto[] => [
    {
      currency: SystemCurrency.OKLP,
      balance: entity.balance,
      depositAddress: entity.depositAddress,
    },
  ]),
  balanceInFiat,
  balanceInCrypto: createSelector(walletState, getBalanceFormatted),
  exchangeRate: createSelector(walletState, ({ entity }: WalletState) => entity.exchangeRate),
  depositAddress: createSelector(walletState, ({ entity }: WalletState) => entity.depositAddress),
};
